import React, { Fragment } from "react"
import { Helmet } from "react-helmet"

import ThemeMenuOne from "../../components/header/ThemeMenuOne"
import CuyOfficeExperience from "../../components/cuy-office/CuyOfficeExperience"
import FooterOne from "../../components/footer/FooterOne"

const CuyOffice = () => {
    return (
        <Fragment>
            <div className="main-page-wrapper">
                <Helmet>
                    <title>Soluciones IT e Innovación Tecnológica en Ecuador</title>
                    <meta
                        name="description"
                        content="CuySoft ofrece soluciones IT integrales en Ecuador: desarrollo web, ciberseguridad, marketing digital y programación. Recorre nuestra oficina virtual."
                    />
                    <meta
                        name="keywords"
                        content="soluciones IT Ecuador, innovación tecnológica, desarrollo web Ecuador, ciberseguridad, marketing digital, programación, CuySoft"
                    />
                    <link rel="canonical" href="https://www.cuysoft.com/" />
                    <meta property="og:title" content="CuySoft – Soluciones IT e Innovación Tecnológica en Ecuador" />
                    <meta
                        property="og:description"
                        content="Soluciones IT integrales: desarrollo web, ciberseguridad, marketing digital y programación para empresas en Ecuador."
                    />
                    <meta property="og:url" content="https://www.cuysoft.com/" />
                </Helmet>

                <ThemeMenuOne />

                <CuyOfficeExperience />

                <FooterOne />
            </div>
        </Fragment>
    )
}

export default CuyOffice
